import React from "react";
import { Col } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import scooterImage from "../../assets/images/motovaltvichele.png";
import backgroundImage from "../../assets/images/background.png";
import circleImage from "../../assets/images/circledown.png";

const LeftSection: React.FC = () => {
  return (
    <Col
      xs={12}
      md={8}
      className="d-flex position-relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <Box sx={{ width: "100%", minHeight: { xs: "50vh", sm: "60vh", md: "100vh" }, position: "relative" }}>
        {/* Overlay Text */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: "15%", sm: "15%", md: "10%" },
            left: { xs: "50%", sm: "50%", md: "40%" },
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            width: { xs: "100%", sm: "100%", md: "100%" },
            textAlign: "center",
            color: "white",
            px: { xs: 2, md: 0 },
          }}
        >
          <Typography
            variant="h1"
            className="fw-bold"
            sx={{
              textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
              lineHeight: 1.2,
              whiteSpace: { xs: "normal", md: "nowrap" },
              fontSize: { xs: "1.2rem", sm: "1.8rem", md: "3rem", lg: "2rem" },
            }}
          >
            LOCATE. SWAP. RIDE.
          </Typography>
          <Typography
            variant="h5"
            sx={{
              opacity: 0.9,
              fontWeight: 400,
              whiteSpace: { xs: "normal", md: "nowrap" },
              fontSize: { xs: "0.75rem", sm: "1rem", md: "1.3rem" },
              mt: 1.5,
            }}
          >
            SWAP PLANS STARTS AT JUST ₹999/MONTH
          </Typography>
        </Box>

        {/* Circle + Scooter */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: { xs: "50%",sm: "45%", md: "42%" },
            transform: "translateX(-50%)",
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={circleImage}
            alt="Circle"
            sx={{ width: { xs: "250px", sm: "400px", md: "650px" }, height: "auto" }}
          />
          <Box
            component="img"
            src={scooterImage}
            alt="Motovolt Scooter"
            sx={{
              position: "absolute",
              bottom: { xs: "0px", sm: "5px", md: "0px" },
              width: { xs: "300px", sm: "430px", md: "730px" },
              height: "auto",
              objectFit: "contain",
              zIndex: 2,
            }}
          />
        </Box>
      </Box>
    </Col>
  );
};

export default LeftSection;
